const footerHr = {
    "follow_us": "Pratite nas!",
    "all_rights_reserved": "2024 Code Kitchen Kft sva prava pridržana",
    "terms_and_conditions": "Uvjeti i odredbe",
    "privacy_policy": "Pravila o privatnosti"
};

export default footerHr;
